module.exports = __webpack_public_path__ + "static/fonts/342F4F_11_0.275dca7.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/342F4F_11_0.eot
// module id = 50
// module chunks = 3